import { Checkbox, Form, CheckboxGroup } from "rsuite"

import "./basicCheckbox.css"

export default function BasicCheckbox({value, label, onChange, checked, ...props}) {
    // <Checkbox color="green" onChange={value => console.log(value)}>{label}</Checkbox>
    return (
        <Form onChange={value => {
            if (value.check.length > 0) onChange(true);
            else onChange(false);
        }}>
            <Form.Control name="check" accepter={CheckboxGroup} value={checked ? [1] : []}>
                <Checkbox value={1}  color="green" {...props}>
                    <span>{label}</span>
                </Checkbox>
            </Form.Control>
        </Form>
    )
}